import ani1 from "../images/avatars/ani1.svg";
import ani2 from "../images/avatars/ani2.svg";
import ani3 from "../images/avatars/ani3.svg";
import ani4 from "../images/avatars/ani4.svg";
import ani5 from "../images/avatars/ani5.svg";
import ani6 from "../images/avatars/ani6.svg";
import ani7 from "../images/avatars/ani7.svg";
import ani8 from "../images/avatars/ani8.svg";
import ani9 from "../images/avatars/ani9.svg";
import ani10 from "../images/avatars/ani10.svg";
import ani11 from "../images/avatars/ani11.svg";
import ani12 from "../images/avatars/ani12.svg";
import ani13 from "../images/avatars/ani13.svg";
import ani14 from "../images/avatars/ani14.svg";
import ani15 from "../images/avatars/ani15.svg";
import ani16 from "../images/avatars/ani16.svg";
import ani17 from "../images/avatars/ani17.svg";
import ani18 from "../images/avatars/ani18.svg";
import ani19 from "../images/avatars/ani19.svg";
import ani20 from "../images/avatars/ani20.svg";

export const avatarImages = {
  ani1: { svg: ani1 },
  ani2: { svg: ani2 },
  ani3: { svg: ani3 },
  ani4: { svg: ani4 },
  ani5: { svg: ani5 },
  ani6: { svg: ani6, anchor: 140 },
  ani7: { svg: ani7 },
  ani8: { svg: ani8 },
  ani9: { svg: ani9 },
  ani10: { svg: ani10 },
  ani11: { svg: ani11 },
  ani12: { svg: ani12 },
  ani13: { svg: ani13 },
  ani14: { svg: ani14, anchor: 140 },
  ani15: { svg: ani15 },
  ani16: { svg: ani16 },
  ani17: { svg: ani17 },
  ani18: { svg: ani18 },
  ani19: { svg: ani19 },
  ani20: { svg: ani20 },
};

export const avatarsRows = [
  [ani1, ani2, ani3, ani4],
  [ani5, ani6, ani7, ani8],
  [ani9, ani10, ani11, ani12],
  [ani13, ani14, ani15, ani16],
  [ani17, ani18, ani19, ani20],
];
